import React from 'react'
import LandingPage from '../components/LandingPage/LandingPage'
export default function Homepage() {
  return (
    <>
    <LandingPage/>
    </>
  )
}
